import styles from './CardTitle.module.css';
import { intrinsicClassName } from '../../utils/reactView';

export const CardTitle = intrinsicClassName('h3', styles.title);
